import { createUseStyles } from 'react-jss';
import { color, spacing } from '@blink/components';

export const useAssetItemStyle = createUseStyles({
    root: {
        color: color.content.primary,
        padding: `${spacing['04']} ${spacing['05']}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '80px',
        width: '100%',
        borderRadius: 0,
        fontSize: '16px',
        lineHeight: '24px',

        '& button': {
            borderRadius: 0,
        },

        '& button:first-child': {
            marginTop: 0,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
        },

        '& button:last-child': {
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
        },

        '&:hover': {
            '& > button': {
                display: 'revert',
            },
        },
    },
    assetIcon: {
        '& div': {
            fontSize: '16px',
        },
    },
    amountWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: spacing['04'],
    },
    assetAmount: {
        margin: 0,
        fontWeight: 600,
        fontSize: '16px',
    },
    clearButton: {
        display: 'none',
    },
});
